<template>
  <div class="form-row">
    <h6 class="sub-frm-title">Download Events Report</h6>
    <div class="col-sm-12">
      <b-card style="border: 1px dotted #07a7e14f;">
        <div class="row">
          <div class="col-sm-8">
            <multiselect
              v-model="selectedTraining"
              :options="trainingListArr"
              label="title"
              placeholder="Search or Select a Events"
              :multiple="true"
              track-by="id"
              :custom-label="customLabel"
            ></multiselect>
          </div>
          <div class="col-sm-4">
            <!-- add button starts-->
            <b-button
              class="download-btn"
              variant="primary"
              @click="getReport"
              :disabled="!selectedTraining"
            >
              Download Sheet
            </b-button>
            <!-- add button ends -->
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { downloadTrainingReport} from '../../utils/DownloadReport';


export default {
    data: () => ({
        trainingListArr: [],
        trainingReport: [],
        selectedTraining: null,
        searchQuery: '',
        training_code: [],
        userId: '',
        userRole: '',
    }),
    mounted() {
        this.userId = JSON.parse(localStorage.getItem("currentUser")).id
        this.userRole = JSON.parse(localStorage.getItem("currentUser")).role_id
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.openLoading();
        if (this.userRole === 1) {
            axios
                .get(localStorage.getItem("BASE_PATH") + "/trainings/get/all")
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.trainingListArr = response.data;
                });
        }
        if (this.userRole === 2) {
            axios
                .get(localStorage.getItem("BASE_PATH") + "/trainings/get/all?user_id=" + this.userId)
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.trainingListArr = response.data;
                });
        }
       if (this.userRole === 3) {
            axios
                .get(localStorage.getItem("BASE_PATH") + "/trainings/get/all?po_id=" + this.userId)
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.trainingListArr = response.data;
                });
        }
    },
    components: {
        Multiselect
    },
    methods: {
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        customLabel(option) {
            return option.title; // Customize the label displayed in the dropdown
        },
        getReport(){
            this.openLoading();
            setTimeout(() => {
                this.closeLoading();
            }, 2000);
           downloadTrainingReport(this.training_code)
        },
        
        

    },
    computed: {
        filteredTrainings() {
            if (!this.searchQuery) {
                return this.trainingListArr;
            }
            const searchLower = this.searchQuery.toLowerCase();
            return this.trainingListArr.filter(training => {
                const titleLower = training.title.toLowerCase();
                return titleLower.includes(searchLower);
            });
        }
    },
    watch: {
        selectedTraining(newValue) {
            this.training_code = newValue.map(item => item.id);
        }
    }
};
</script>

<style scoped>
@media (max-width: 768px) {}
</style>
